var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Local de Lotação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.localLotacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "localLotacao", $$v);
      },
      expression: "form.filters.localLotacao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "GRE",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.gre,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "gre", $$v);
      },
      expression: "form.filters.gre"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Município",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.municipio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "municipio", $$v);
      },
      expression: "form.filters.municipio"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 2,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    model: {
      value: _vm.form.filters.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "situacao", $$v);
      },
      expression: "form.filters.situacao"
    }
  }), _c('sca-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicio", $$v);
      },
      expression: "form.filters.dataInicio"
    }
  }), _c('sca-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFim", $$v);
      },
      expression: "form.filters.dataFim"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": _vm.buscarRelatorios
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": _vm.resetForm
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5 printable",
    attrs: {
      "headers": _vm.headersAnalitico,
      "items": _vm.form.lists.listRelatorios,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "sort-by": "dataAcao",
      "sort-desc": true
    },
    scopedSlots: _vm._u([{
      key: `item.localLotacao`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.localLotacao) + " ")];
      }
    }, {
      key: `item.gre`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.gre) + " ")];
      }
    }, {
      key: `item.municipio`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.municipio) + " ")];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.situacao,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.dataAcao`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm.$formatarDataHora(item.dataAcao)) + " ")];
      }
    }, {
      key: `item.acao`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(item.acao) + " ")];
      }
    }], null, true)
  }), _vm.form.lists.listRelatorios.length ? _c('sca-buttons', {
    attrs: {
      "actionText": "Baixar PDF",
      "cancelText": "Baixar CSV"
    },
    on: {
      "click": _vm.baixarRelatorioPdf,
      "cancel": _vm.baixarCSVRelatorio
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }